import { render, staticRenderFns } from "./create-registration-tool-bar.vue?vue&type=template&id=905a4ab8&scoped=true"
import script from "./create-registration-tool-bar.vue?vue&type=script&lang=js"
export * from "./create-registration-tool-bar.vue?vue&type=script&lang=js"
import style0 from "./create-registration-tool-bar.vue?vue&type=style&index=0&id=905a4ab8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905a4ab8",
  null
  
)

export default component.exports